var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Toggle } from "../../toggle";
// components
import { StyledWrapper, StyledList } from "./Wrappers.styles";
import { FlyoutItem } from "./FyloutItem";
import { StyledFlyoutListItem } from "./FlyoutItem.styles";
export function Flyout(_a) {
    var { items, type, outlined, children, inputValue, value, onItemChange, onItemsChange, initialSelectedItem, initialHoveredItemIndex, onHoveredItemIndexChange, initialSelectedItems = [], values, previewId, previewIdExtractor } = _a, props = __rest(_a, ["items", "type", "outlined", "children", "inputValue", "value", "onItemChange", "onItemsChange", "initialSelectedItem", "initialHoveredItemIndex", "onHoveredItemIndexChange", "initialSelectedItems", "values", "previewId", "previewIdExtractor"]);
    const [focused, setFocused] = useState(false);
    const [hoveredItemIndex, setHoveredItemIndex] = useState(-1);
    const fieldName = props.name;
    const [selectedValue, setSelectedValue] = useState(initialSelectedItem);
    const [selectedValues, setSelectedValues] = useState(initialSelectedItems);
    const itemsNeedSpacingToTheLeft = type === "withIcon" || items.some((e) => Boolean(e.symbol));
    function handleItemChange(item) {
        var _a;
        setSelectedValue(item.value || ((_a = item.content) === null || _a === void 0 ? void 0 : _a.value));
        if (onItemChange) {
            onItemChange(item);
        }
    }
    useEffect(() => {
        if (selectedValue !== value) {
            setSelectedValue(value);
        }
    }, [value]);
    useEffect(() => {
        setHoveredItemIndex(initialHoveredItemIndex);
    }, [initialHoveredItemIndex]);
    useEffect(() => {
        if (values) {
            setSelectedValues(values);
        }
    }, [values]);
    function handleToogleChange(item) {
        let newValues = [];
        if (selectedValues.includes(item.value))
            newValues = selectedValues.filter((itemVal) => itemVal !== item.value);
        else
            newValues = [...selectedValues, item.value];
        setSelectedValues(newValues);
        if (onItemsChange) {
            onItemsChange(newValues);
        }
    }
    const results = items;
    return (_jsxs(StyledWrapper, Object.assign({ "data-preview-id": previewId, outlined: outlined }, { children: [_jsx(StyledList, Object.assign({ onMouseDown: () => setFocused(false), onKeyUp: (event) => {
                    if (event.key === "Tab") {
                        setFocused(true);
                    }
                } }, { children: results
                    .map((item, itemIndex) => {
                    var _a, _b;
                    const flyoutItem = "content" in item && (_jsx(FlyoutItem, Object.assign({ symbol: type === "withIcon" && selectedValue === item.value
                            ? "Checkmark"
                            : "" }, item, { inputValue: inputValue })));
                    const flyoutItems = type === "checkbox" ? [Object.assign({}, item)] : items;
                    return (_jsxs(StyledFlyoutListItem, Object.assign({ "data-preview-id": typeof previewIdExtractor === "function"
                            ? previewIdExtractor(item, itemIndex)
                            : undefined, focused: focused, onClick: () => {
                            if (item.disabled) {
                                return;
                            }
                            if (type !== "checkbox") {
                                handleItemChange(item);
                            }
                            if (props.onClick) {
                                props.onClick(item);
                            }
                        }, onKeyDown: (event) => {
                            if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                if (type === "checkbox") {
                                    handleToogleChange(item);
                                }
                                else {
                                    handleItemChange(item);
                                }
                            }
                        }, hovered: hoveredItemIndex === itemIndex, onMouseEnter: () => {
                            setHoveredItemIndex(itemIndex);
                            if (onHoveredItemIndexChange) {
                                onHoveredItemIndexChange(itemIndex);
                            }
                        }, onMouseLeave: () => setHoveredItemIndex(-1), symbol: "Checkmark", type: type, tabIndex: !item.disabled ? 0 : -1, disabled: item.disabled, isActive: selectedValue &&
                            (selectedValue === item.value ||
                                selectedValue === ((_a = item.content) === null || _a === void 0 ? void 0 : _a.value)), "data-testid": "flyout-input", leftSpace: itemsNeedSpacingToTheLeft }, { children: [type === "checkbox" ? (_jsx(Toggle, { type: type, items: flyoutItems && flyoutItems, isFlyout: true, values: {
                                    [fieldName]: selectedValues,
                                }, name: fieldName, disabledStates: true, onChange: () => {
                                    handleToogleChange(item);
                                } })) : null, flyoutItem] }), item.content
                        ? (_b = item.content) === null || _b === void 0 ? void 0 : _b.value
                        : item.value));
                })
                    .filter(Boolean) })), _jsx(_Fragment, { children: children })] })));
}
